module.exports = __webpack_public_path__ + "static/media/50.b94ff0af.svg";